import React from 'react'
import Image from 'next/image'
import YellowStar from '../../public/static/star/yellowstar.svg'
import IconFresh from '../../public/static/icon_fresh.svg'
import { UserResponse } from '../../types/users/user-response'
import { ThemeEnum } from '../../common/enums/theme.enum'

type Props = {
  teammate: UserResponse | null | undefined
  mode?: string
  starSize?: number
  textFont?: string
  showTotalReview?: boolean
  totalReviewFont?: string
}

const isNotNullOrUndefined = (value: any) => {
  return value !== undefined && value !== null
}

const isValidRating = (teammate: UserResponse | null | undefined) => {
  return (
    teammate?.averageRating !== '' &&
    isNotNullOrUndefined(teammate?.averageRating)
  )
}

const isValidReviewsCount = (teammate: UserResponse | null | undefined) => {
  return (
    // @ts-ignore
    isNotNullOrUndefined(teammate?.reviewsCount) && teammate?.reviewsCount > 0
  )
}

export default function RatingSection({
  teammate,
  mode = ThemeEnum.DARK,
  starSize = 4,
  textFont = ' text-secondary-normal text-color-gray5',
  showTotalReview,
  totalReviewFont = ' text-secondary-normal text-fizz-200',
}: Props) {
  return isValidReviewsCount(teammate) ? (
    <div className={'flex flex-row items-center'}>
      <div className={`relative h-${starSize} w-${starSize}`}>
        <Image
          src={YellowStar}
          fill={true}
          className={'object-contain'}
          alt={'Yellow star'}
        />
      </div>
      <p className={` ${textFont} ml-0.5`}>
        {isValidRating(teammate) ? teammate?.averageRating : '--'}
      </p>

      {showTotalReview && (
        <p className={` ${totalReviewFont} ml-0.5`}>
          {`(${teammate?.reviewsCount ?? 0})`}
        </p>
      )}
    </div>
  ) : (
    <div className={'flex flex-row items-center py-0.5'}>
      <div className={`relative h-${starSize} w-${starSize} -ml-1`}>
        <Image
          src={IconFresh}
          fill={true}
          className={'object-contain'}
          alt={'Yellow star'}
        />
      </div>
      <p className={`${textFont} ml-1 mr-1`}>New</p>
    </div>
  )
}
